/// <reference path="../../../../typings/index.d.ts" />
(function ($) {
    var st_s_r = 0;
    var punkt = 0;
    getUrlVars();
    load_cat('x', 'x', 1, 1, st_s_r, punkt);
    $('.category').click(function (event) {
        $('.page_data').hide()
        load_cat($(this).attr('data-id'), 'x', 1, 1, st_s_r, punkt);
        return false;
    });
    $('.subcategory').click(function (event) {
        $('.page_data').hide()
        load_cat($(this).attr('data-cid'), $(this).attr('data-id'), 1, 1, st_s_r, punkt);
        return false;
    });
    $('.status_button button').click(function (event) {
        change_st($(this), event)
    });

    function getUrlVars() {
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            var hash = hashes[i].split('=');
            if (hash[0] == 'in_stock') {
                $('.in_stock').addClass('act_punkt');
                punkt = 1;
            }
            else if (hash[0] == 'row') {
                $('.in_row').addClass('act_punkt');
                punkt = 1;
            }
            else if (hash[0] == 'reserve') {
                $('.reserve').addClass('act_punkt');
                punkt = 2;
            } else if (hash[0] == 'in_collection') {
                $('.in_collection').addClass('act_punkt');
                punkt = 3;
            }
            else {
                $('.riady').addClass('act_punkt');
            }
        }
    }

    function change_st(zdes, event) {
        st_s_r = zdes.attr('data-st');
        $('.status_button button').css('border', '1px solid #68C177');
        zdes.css('border', 'solid #6B6B6B 1px');
        if ($('.category.act')) {
            var p_cat: any = $('.category.act').attr('data-id');
        }
        else {
            var p_cat: any = 'x';
        }
        if ($('.subcategory.act')) {
            var p_sub: any = $('.subcategory.act').attr('data-id');
        }
        else {
            var p_sub: any = 'x';
        }
        load_cat(p_cat, p_sub, 1, 1, st_s_r, punkt);
    }

    function load_cat(category, subcategory, page, clear, status_s_r, punkt) {
        var dat = {};
        if (category != 'x' && subcategory != 'x') {
            dat = {category: category, subcategory: subcategory};
        }
        else if (category != 'x') {
            dat = {category: category}
        }

        if (punkt == 1) {
            dat['in_stock'] = true;
        }
        else if (punkt == 2) {
            dat['reserve'] = true;
        }
        else if (punkt == 3) {
            dat['in_collection'] = true;
        }
        $.ajax({
            type: 'GET',
            url: 'get/rows?page=' + page + '&status=' + status_s_r,
            data: dat,
            dataType: 'json',
            beforeSend: function () {
                if (clear == 1) {
                    $('.rightcol').html('');
                    $('.loader').show();
                }
                else {
                    //$('.button_load_next').remove();
                    $('.rightcol').append('<div class="loader2"><img src="img/load3.gif"/></div>');
                }
                $(window).unbind();
            },
            success: function (data) {
                $('.category').removeClass('act').filter(function () {
                    return $(this).attr('data-id') == dat['category']
                }).addClass('act');
                $('.subcategory').removeClass('act').filter(function () {
                    return $(this).attr('data-id') == dat['subcategory']
                }).addClass('act');
                if (data.result.length != 0) {
                    $.each(data.result, function (key, value) {
                        $('.cart_tov_template').clone(true)
                            .appendTo('.rightcol');
                        $('.rightcol .cart_tov_template').attr('data-id', value.id);
                        $('.rightcol .cart_tov_template .ssylka a').html(value.url).attr('href', value.url);
                        $('.rightcol .cart_tov_template .name').html(value.name);
                        $('.rightcol .cart_tov_template .articul span').html(value.article);
                        $('.rightcol .cart_tov_template .price').append(value.price);
                        if (value.markup != '') {
                            $('.rightcol .cart_tov_template .price').append(' + %');
                        }
                        $.each(value.sizes, function (key2, value2) {
                            $('.sizes_template').clone(true)
                                .appendTo('.rightcol .cart_tov_template .cont');
                            $.each(value2.img, function (key4, value4) {
                                $('.rightcol .cart_tov_template .sizes_template .cart_images_template').append('<img src="' + value4.picture_original + '" />');
                            });
                            $('.rightcol .cart_tov_template .sizes_template .cart_images_template').removeClass('cart_images_template');
                            $.each(value2.sizes, function (key3, value3) {
                                $('.pachka_template').clone(true)
                                    .appendTo('.rightcol .cart_tov_template .cont .sizes_template');
                                $('.rightcol .cart_tov_template .sizes_template .pachka_template .status').html(value3.statusName);
                                $('.rightcol .cart_tov_template .sizes_template .pachka_template .color').html(value3.color);
                                if (value3.invoice != '') {
                                    $('.rightcol .cart_tov_template .pachka_template .tochka').addClass('tochka_e');
                                }
                                else {
                                    $('.rightcol .cart_tov_template .pachka_template .tochka').addClass('tochka_n');
                                }
                                $.each(value3.sizes, function (key4, value4) {
                                    $('.sizes_template_2').clone(true)
                                        .appendTo('.rightcol .sizes_template .pachka_template');
                                    $('.rightcol .sizes_template .pachka_template .sizes_template_2').attr('data-id', value4.id);
                                    $('.rightcol .sizes_template .pachka_template .sizes_template_2 .pozh').html(value4.note);
                                    $('.rightcol .sizes_template .pachka_template .sizes_template_2 .status_size').html(value4.statusName);
                                    $('.rightcol .sizes_template .pachka_template .sizes_template_2 .status_size').addClass('st' + value4.status);
                                    if (/\S/.test(value4.note)) {
                                        $('.rightcol .cart_tov_template .pachka_template .sizes_template_2 .pozh').css('border-bottom', '1px dashed #FF6600')
                                    }
                                    $('.rightcol .cart_tov_template .pachka_template .sizes_template_2 .marking').html(value4.marking);
                                    $('.rightcol .cart_tov_template .pachka_template .sizes_template_2 .size').html('(' + value4.size + ')');
                                    $('.rightcol .cart_tov_template .pachka_template .sizes_template_2 .user').html(value4.user);
                                    if (~$('.rightcol .cart_tov_template .pachka_template .sizes_template_2 .user').html().indexOf('ИЩЕМ')) {
                                        $('.rightcol .cart_tov_template .pachka_template .sizes_template_2 .user').css('color', '#03F')
                                    }
                                    $('.rightcol .cart_tov_template .pachka_template .sizes_template_2 .akc').html(value4.markup + '%');
                                    $('.rightcol .cart_tov_template .pachka_template .sizes_template_2').css('display', 'table')
                                        .removeClass('sizes_template_2');
                                });
                                $('.rightcol .cart_tov_template .sizes_template .pachka_template').css('display', 'block').removeClass('pachka_template');
                            });
                            $('.rightcol .cart_tov_template .sizes_template').css('display', 'block').removeClass('sizes_template');
                        });
                        $('.rightcol .cart_tov_template').css('display', 'block')
                            .removeClass('cart_tov_template');
                    });
                }
                else {
                    $('.rightcol').html('<p>По вашему запросу товар не найден</p>');
                }
                if (data.paginate.next_page != false) {
                    // $('.rightcol').append('<button class="button_load_next">Ещё</button>');
                    $('.loader').show();
                    $(window).scroll(function () {
                        if ($(document).scrollTop() + $(window).innerHeight() * 2 >= $(document).innerHeight()) {
                            load_cat($('.category.act').attr('data-id'), $('.subcategory.act').attr('data-id'), data.paginate.next_page, 0, st_s_r, punkt);
                        }
                    });
                }
            },
            complete: function () {
                $('.loader').hide();
                $('.loader2').remove();
            }
        })
    }

    $('.rightcol').on('click', '.cart_images img', function (event) {
        $('.img_modal_loader img').attr('src', $(this).attr('src'));
        $('#img_modal').modal({
            backdrop: 'static'
        });
        console.log(event)
    });

    // прокрутка страницы
    $(document).ready(function () {
        //Обработка нажатия на кнопку "Вверх"
        $("#up").click(function () {
            //Необходимо прокрутить в начало страницы
            var curPos = $(document).scrollTop();
            var scrollTime = curPos / 25;
            $("body,html").animate({"scrollTop": 0}, scrollTime);
        });
        //Обработка нажатия на кнопку "Вниз"
        $("#down").click(function () {
            //Необходимо прокрутить в конец страницы
            var curPos = $(document).scrollTop();
            var height = $("body").height();
            var scrollTime = (height - curPos) / 25;
            $("body,html").animate({"scrollTop": height}, scrollTime);
        });
    });
})(jQuery);